import http from '../config/http';
import routes from '../config/api_routes';

export const getActiveTermsAndConditions = () => http(true).get(routes.terms.getActive)